import "./EditHistory.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from "../config";

export default function EditHistory( { preview } ) {

  const [items, setItems] = useState();
  let oldItems = [];
  let newItems = [];
  let hasFetched = false;

  useEffect(() => {
    var _str = "https://api.tzkt.io/v1/accounts/"
    var _str2 = "/operations";
    if(preview){
      _str2 = _str2 + "?limit=10";
    }else{
      //_str2 = _str2 + "?limit=250";
    }
    fetch(_str + config.contractAddress + _str2)
    .then(response => response.json())
    .then((data) => {
      var _newData = [];
      for(var i=0; i<data.length; i++){
        if(data[i].parameter && data[i].parameter.value && data[i].parameter.value.xpos){
          _newData.push(data[i]);
        }
      }
      //console.log(data);
      //console.log(_newData);
      newItems = _newData;
    });

    fetch(_str + "KT1L2xY7fZZh4kvDmnjdQzereHAD5PnME5fg" + _str2)
    .then(response => response.json())
    .then((data) => {
      var _newData = [];
      for(var i=0; i<data.length; i++){
        if(data[i].parameter && data[i].parameter.value && data[i].parameter.value.xpos){
          _newData.push(data[i]);
        }
      }
      //console.log(data);
      //console.log(_newData);
      oldItems = _newData;
    });

  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if(!hasFetched && oldItems.length > 0 && newItems.length > 0){
        var _newData = [];
        for(var i=0; i<newItems.length; i++){
          if((!preview && _newData.length < 100) || _newData.length < 10) _newData.push(newItems[i]);
        }
        for(var i=0; i<oldItems.length; i++){
          if((!preview && _newData.length < 100) || _newData.length < 10) _newData.push(oldItems[i]);
        }
        setItems(_newData);
        hasFetched = true
        //console.log("ayo");
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [])

  return (
    <div className="edit-history">
 
      <h1>Edit History</h1>

      {items && <Panel items={items} />}

      <br />
      {preview && <Link to="/PixelPlace/history">View last 100 edits</Link>}
      <br />
      <br />

    </div>
  );
}

function Panel({ items }){

  return(
    <>
      <table>
        {items.map(item => (
            <tr>
              <th>{new Date(item.timestamp).toDateString()}</th>
              <th><i>{new Date(item.timestamp).toTimeString().split(" ")[0]}</i></th>
              <th><a href={"https://tzkt.io/" + item.sender.address}>{item.sender.alias || (item.sender.address.substring(0,5) + "..." + item.sender.address.slice(-5))}</a></th>
              <th>x: {item.parameter.value.xpos || 0}</th>
              <th>y: {item.parameter.value.ypos || 0}</th>
              <th>color: {item.parameter.value.color || 0}</th>
            </tr>
        ))}
      </table>
    </>
  );
}